<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="w-12 h-12 rounded-lg text-white p-1 bg-tertiary"
      >
        <icon name="html_mailers" />
      </div>
      <h3 class="text-2xl font-medium ml-4">
        Valuation Mailers
      </h3>
    </div>
    <div>
      <label class="label-xs">
        Type
      </label>
      <pl-select
        class="w-full"
        select-class="input-xs"
        v-model="module.settings.type"
      >
        <option disabled>Please Select</option>
        <option value="pre">Pre-Valuation</option>
        <option value="post">Post-Valuation</option>
      </pl-select>
    </div>
  </div>
</template>

<script>
export default {
  props: ['module']
}
</script>
